export type PricingFlag = 'PP' | 'PF';

export class WholesalerSimulation {
  id!: number;
  pharmacyRefId!: number;
  wholesalerId!: number;
  wholesalerName?: string;
  year?: number;
  base?: string;
  type?: string;
  quantity?: number;
  grossAmountExclTax?: number;
  grossManufacturerAmountExclTax?: number;
  discountEuroExclTax?: number;
  discountPercent?: number;
  netAmountExclTax?: number;
  grossPercentileTarget?: number;
  cooperationTargetBox?: number;
  totalCooperation?: number;
  ordreAssiette?: number;
  netTotalSimulation?: number;
  descriptionAssiette?: string;
  flagPrix?: PricingFlag;

  static fromBackend(data: any): WholesalerSimulation {
    return {
      id: data.id,
      pharmacyRefId: data.idOfficineRef,
      wholesalerId: data.idGrossiste,
      wholesalerName: data.nomGrossiste,
      year: data.annee,
      base: data.assiette,
      type: data.type,
      quantity: data.quantite,
      grossAmountExclTax: data.montantBrutHt,
      grossManufacturerAmountExclTax: data.montantBrutHT_PF,
      discountEuroExclTax: data.remiseEuroHt,
      discountPercent: data.remisePourcent,
      netAmountExclTax: data.montantNetHt,
      totalCooperation: data.montantCoop ?? 0,
      ordreAssiette: data.ordreAssiette,
      descriptionAssiette: data.descriptionAssiette,
      flagPrix:
        data.flagPrix === 'PP' || data.flagPrix === 'PF'
          ? (data.flagPrix as PricingFlag)
          : undefined,
    } as WholesalerSimulation;
  }

  static fromBackendList(data: any[]): WholesalerSimulation[] {
    return data.map(item => WholesalerSimulation.fromBackend(item));
  }
}
